import { useMemo } from 'react';
import Grid from '../grid/Grid';
import { StorageKeys } from '../constants/storageKeys';
import GridCell from '../grid/GridCell';
import useInteractions from '../../hooks/useInteractions';

const Interactions = ({ scenario }) => {
    const { interactions } = useInteractions(scenario);

    const data = useMemo(() => interactions?.list || [], [interactions])

    const columns = useMemo(() => {
        if (!interactions?.scheme) {
            return [];
        }

        return interactions.scheme.map((column) => {
            return {
                Header: column.header,
                accessor: column.id,
                Cell: (props) => <GridCell {...props} format={column.format} />,
                width: column.format === 'icon' ? 60 : 200,
                ...(column.format === 'number' ? {
                    sortType: 'numeric',
                } :  {
                    sortType: 'alphanumeric',
                }),
            }
        });
    }, [interactions])

    if (!scenario) {
        return (
            <div>Selecteer een scenario</div>
        )
    }

    return (
        <div className="grid__wrapper">
            <Grid
                data={data}
                columns={columns}
                storageKey={StorageKeys.GridInteractions}
                getRowProps={() => {
                    return {
                        className: 'row',
                    }
                }}
            />
        </div>
    )
}

export default Interactions;
